import type { RouteObject } from 'react-router-dom'
import Home from '@/pages/Home'
import Admin from '@/pages/Admin'
import { useRoutes } from 'react-router-dom'

// Used in @/prerender.tsx
export const routes: RouteObject[] = [
  { path: '/', element: <Home /> },
  { path: '/admin', element: <Admin /> },
]

function App() {
  return useRoutes(routes)
}

export default App
